import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import ImageFlow from '@/modules/adjusterReportModules/IncidentParticipants/pages/common/imageFlow/ImageFlow';
import { useNavigate, useParams } from 'react-router-dom';

const DamagedImageFlow = () => {
  const navigate = useNavigate();
  const params = useParams();

  const finishFlow = () => {
    navigate(
      ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
        damagedId: params.damagedId!,
        id: params.id!,
      }).ADJUSTER_VEHICLE.previewImages,
      { replace: true },
    );
  };
  const navigateBack = () => {
    navigate(
      ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
        damagedId: params.damagedId!,
        id: params.id!,
      }).ADJUSTER_VEHICLE.damagedPoints,
      { replace: true },
    );
  };
  return (
    <ImageFlow
      finishFlow={finishFlow}
      navigateBack={navigateBack}
      filetype="property"
    />
  );
};

export default DamagedImageFlow;
